import React from 'react';
import { Paintbrush, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-charcoal text-warmWhite pt-20 pb-10" data-id="element-19">
      <div className="container mx-auto px-4 md:px-6" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-21">
          {/* Column 1: Company Info */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-22">
            <a href="#" className="flex items-center gap-2 text-white mb-6" data-id="element-23">
              <Paintbrush className="w-6 h-6 text-gold" data-id="element-24" />
              <span className="font-heading font-bold text-xl tracking-tight" data-id="element-25">
                [Company Name]
              </span>
            </a>
            <p className="text-warmWhite/70 mb-6 leading-relaxed" data-id="element-26">
              Expert painting and remodeling services. Elevating homes with
              quality craftsmanship and attention to detail.
            </p>
            <div className="space-y-3 text-warmWhite/80" data-id="element-27">
              <div className="flex items-center gap-3 justify-center md:justify-start" data-id="element-28">
                <Phone className="w-5 h-5 text-gold" data-id="element-29" />
                <span data-id="element-30">(555) 123-4567</span>
              </div>
              <div className="flex items-center gap-3 justify-center md:justify-start" data-id="element-31">
                <Mail className="w-5 h-5 text-gold" data-id="element-32" />
                <span data-id="element-33">hello@companyname.com</span>
              </div>
              <div className="flex items-center gap-3 justify-center md:justify-start" data-id="element-34">
                <MapPin className="w-5 h-5 text-gold" data-id="element-35" />
                <span data-id="element-36">Serving the Greater Area</span>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-37">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-38">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-41">
                  Home
                </a>
              </li>
              <li data-id="element-42">
                <a href="#services" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-43">
                  Services
                </a>
              </li>
              <li data-id="element-44">
                <a href="#portfolio" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-45">
                  Portfolio
                </a>
              </li>
              <li data-id="element-46">
                <a href="#about" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-47">
                  About Us
                </a>
              </li>
              <li data-id="element-48">
                <a href="#contact" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-49">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-50">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-51">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-52">
              <li data-id="element-53">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-54">
                  Interior Painting
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-56">
                  Exterior Painting
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-58">
                  Kitchen Remodeling
                </a>
              </li>
              <li data-id="element-59">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-60">
                  Bathroom Remodeling
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="text-warmWhite/70 hover:text-gold transition-colors" data-id="element-62">
                  Flooring Installation
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Form CTA */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-63">
            <h4 className="font-heading font-bold text-lg mb-6 text-white" data-id="element-64">
              Get In Touch
            </h4>
            <p className="text-warmWhite/70 mb-6" data-id="element-65">
              Ready to start your project? Contact us today for a free estimate.
            </p>
            <form className="w-full max-w-sm space-y-3" onSubmit={e => e.preventDefault()} data-id="element-66">
              <input type="text" placeholder="Your Name" className="w-full bg-white/5 border border-white/10 rounded px-4 py-2 text-white placeholder:text-white/40 focus:outline-none focus:border-gold transition-colors" data-id="element-67" />
              <input type="tel" placeholder="Phone Number" className="w-full bg-white/5 border border-white/10 rounded px-4 py-2 text-white placeholder:text-white/40 focus:outline-none focus:border-gold transition-colors" data-id="element-68" />
              <button type="submit" className="w-full bg-gold text-charcoal font-semibold py-2.5 rounded hover:bg-gold/90 transition-colors" data-id="element-69">
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-70">
          <p className="text-warmWhite/50 text-sm text-center md:text-left" data-id="element-71">
            © 2026 [Company Name]. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-72">
            <a href="#" className="text-warmWhite/50 hover:text-gold transition-colors" aria-label="Facebook" data-id="element-73">
              <Facebook className="w-5 h-5" data-id="element-74" />
            </a>
            <a href="#" className="text-warmWhite/50 hover:text-gold transition-colors" aria-label="Instagram" data-id="element-75">
              <Instagram className="w-5 h-5" data-id="element-76" />
            </a>
            {/* Using a generic globe icon for Google/Website as lucide doesn't have a specific Google G icon */}
            <a href="#" className="text-warmWhite/50 hover:text-gold transition-colors" aria-label="Google" data-id="element-77">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-78">
                <path d="M2 12a10 10 0 1 0 20 0 10 10 0 1 0-20 0" data-id="element-79" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" data-id="element-80" />
                <path d="M2 12h20" data-id="element-81" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}